import { cn } from '~/utils/cn';

import Button from '../../atoms/Button/view';
import { Icon } from '../../atoms/Icon/view';
import { Text } from '../../atoms/Text/view';
import type { propsIconsNames } from '../../atoms/Icon/interfaces';

interface PropsEmptyState {
  icon?: propsIconsNames;
  title: string;
  description?: string;
  ctaText?: string;
  onClickCta?: () => void;
  className?: string;
}

export default function EmptyState({
  icon = 'icon-document',
  title,
  description,
  ctaText,
  onClickCta,
  className,
}: PropsEmptyState) {
  return (
    <div className={cn('flex flex-col items-center text-center px-small py-large', className)}>
      <div className="h-[72px] w-[72px] rounded-full bg-support-01 flex items-center justify-center">
        <Icon name={icon} size={32} color="#1D4733" />
      </div>
      <Text className="mt-small text-paragraphLG color-complement-01">{title}</Text>
      {description ? (
        <Text className="mt-quark text-bodySM color-intense-06">{description}</Text>
      ) : null}
      {ctaText && onClickCta ? (
        <Button text={ctaText} onClick={onClickCta} className="mt-medium" />
      ) : null}
    </div>
  );
}
